import { FlagService as IFlagService } from '../Workflow/types';

export class FlagService implements IFlagService {
  public constructor(private flagEnabled: (flag: string) => boolean) {}

  public getEnabledFlags() {
    return {
      isEmbeddedContentEnabled: this.flagEnabled('ld-embedded-content'),
    };
  }
}
